import { render, staticRenderFns } from "./ConversationApproval.vue?vue&type=template&id=8ebed8d6&scoped=true&"
import script from "./ConversationApproval.vue?vue&type=script&lang=js&"
export * from "./ConversationApproval.vue?vue&type=script&lang=js&"
import style0 from "./ConversationApproval.vue?vue&type=style&index=0&id=8ebed8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebed8d6",
  null
  
)

/* custom blocks */
import block0 from "./ConversationApproval.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports